"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmModal = void 0;
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
exports.SmModal = (0, react_1.forwardRef)((_a, ref) => {
    var _b, _c, _d, _e, _f, _g;
    var { open, backdrop = true, direction = 'right', onOpen, onClose, children } = _a, props = __rest(_a, ["open", "backdrop", "direction", "onOpen", "onClose", "children"]);
    const innerRef = react_1.default.useRef(null);
    react_1.default.useImperativeHandle(ref, () => innerRef.current);
    if (open && !((_b = innerRef.current) === null || _b === void 0 ? void 0 : _b.open)) {
        (_c = innerRef.current) === null || _c === void 0 ? void 0 : _c.removeAttribute('closing');
        if (backdrop) {
            (_d = innerRef.current) === null || _d === void 0 ? void 0 : _d.showModal();
        }
        else {
            (_e = innerRef.current) === null || _e === void 0 ? void 0 : _e.show();
        }
        (_f = innerRef.current) === null || _f === void 0 ? void 0 : _f.focus();
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    }
    else {
        (_g = innerRef.current) === null || _g === void 0 ? void 0 : _g.setAttribute('closing', '');
    }
    const drawerClassnames = (0, classnames_1.default)('c-modal', `-${direction}`);
    return (react_1.default.createElement("dialog", Object.assign({}, props, { tabIndex: 0, className: drawerClassnames, ref: innerRef, onClose: () => onClose === null || onClose === void 0 ? void 0 : onClose(), onKeyDown: (event) => {
            var _a;
            if (event.key === 'Escape') {
                event.preventDefault();
                (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.setAttribute('closing', '');
            }
        }, onClick: (event) => {
            var _a, _b;
            const rect = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            if (rect &&
                (event.clientY < rect.top ||
                    event.clientY > rect.bottom ||
                    event.clientX < rect.left ||
                    event.clientX > rect.right)) {
                (_b = innerRef.current) === null || _b === void 0 ? void 0 : _b.setAttribute('closing', '');
            }
        }, onAnimationEnd: (e) => {
            var _a;
            if (e.animationName === 'fade-out') {
                (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.close();
            }
        } }), children));
});
//# sourceMappingURL=index.js.map